














































































































import Vue from 'vue';
import { ChooseFileFromVault } from '@/components/my-documents-components/my-documents-modal';
import { dateFormat, dateTransactionFormat, dialogMaxWidth } from '@/constants';
import { EventBus } from '@/event-bus';
import { VaultDataResponseModel } from '@/@types/member';

interface Data {
  uploadedDocuments: any[];
  selectedDocuments: any[];
  fileTypeError: boolean;
  myDocumentsModal: boolean;
  filesWithError: any[];
  totalFileSize: number;
  showRemoveFileDialog: boolean;
  removeFileIndex: number;
  removeFile: any;
  dateFormat: string;
  dateTransactionFormat: string;
  dialogMaxWidth: string;
}

export default Vue.extend({
  props: {
    attachDisabled: {
      type: Boolean,
      default: false,
    },
    guidelines: {
      type: String,
      required: true,
    },
    singularUpload: {
      type: Boolean,
      default: false,
    },
    hideEvault: {
      type: Boolean,
      default: false,
    },
    initialDocuments: {
      type: Array as () => any[],
      default: () => [],
    },
    chooseFromVaultSubtitle: {
      type: String,
      default: '',
    },
  },
  data(): Data {
    return {
      uploadedDocuments: [],
      selectedDocuments: this.initialDocuments.slice(),
      fileTypeError: false,
      myDocumentsModal: false,
      filesWithError: [],
      totalFileSize: 0,
      showRemoveFileDialog: false,
      removeFileIndex: null,
      removeFile: {},
      dateFormat,
      dateTransactionFormat,
      dialogMaxWidth,
    };
  },
  beforeMount() {
    // Loop through initial documents and get the document from its ID
    this.selectedDocuments.forEach((documentID, index) => {
      const document = this.getDocumentFromVault(documentID);
      document.name = document.fileNickname || document.fileName;
      this.selectedDocuments[index] = document;
    });
    this.validateSelectedDocuments();
  },
  mounted() {
    // Set up listener for remove selected file
    EventBus.$on('removeSelectedFile', (index, file) => {
      this.removeDocument(index, file);
    });
  },
  destroyed() {
    EventBus.$off('removeSelectedFile');
  },
  methods: {
    attachDocumentsFromEvault(selectedDocuments): void {
      selectedDocuments.forEach((documentID) => {
        const document = this.getDocumentFromVault(documentID);
        document.name = document.fileNickname || document.fileName;
        this.selectedDocuments.push(document);
      });
      this.validateSelectedDocuments(true);
    },
    getDocumentFromVault(documentID): VaultDataResponseModel {
      return this.$store.getters.getVaultDocumentByID(documentID);
    },
    triggerRemoveDocumentDialog(index, file): void {
      this.removeFileIndex = index;
      this.removeFile = file;
      this.showRemoveFileDialog = true;
    },
    removeDocument(index, file): void {
      let selectedFile;
      if (file.vaultId) {
        selectedFile = this.selectedDocuments.find((item) => {
          return file.vaultId === item.vaultId;
        });
        this.selectedDocuments.splice(
          this.selectedDocuments.indexOf(selectedFile),
          1,
        );
      } else {
        selectedFile = this.uploadedDocuments.find((item) => {
          return (
            file.name + file.lastModified === item.name + item.lastModified
          );
        });
        this.uploadedDocuments.splice(
          this.uploadedDocuments.indexOf(selectedFile),
          1,
        );
      }
      this.showRemoveFileDialog = false;
    },
    uploadSelectedFile(value): void {
      Object.keys(value.target.files).forEach((key) => {
        const FILE_OBJECT = value.target.files[key];
        // Check if last modified exists on the file object, if not set it to a string of lastModifiedDate
        // This is to fix IE11 which doesn't include lastModified by default
        if (!FILE_OBJECT.lastModified) {
          FILE_OBJECT.lastModified = FILE_OBJECT.lastModifiedDate.toString();
        }
        this.uploadedDocuments.push(FILE_OBJECT);
      });
      this.validateUploadedDocuments();
      (this.$refs.uploadForm as any).reset();
    },
    validateUploadedDocuments(): void {
      // Remove duplicate files by name
      this.uploadedDocuments = this.removeDuplicates(
        this.uploadedDocuments,
        'name',
        'lastModified',
      );
      // Remove file types that are not allowed for upload
      this.fileTypeError = false;
      this.filesWithError = [];
      this.totalFileSize = 0;
      this.fileTypeValidation();
      this.fileSizeValidation();
    },
    validateSelectedDocuments(evaultSelection = false): void {
      // Remove duplicate files by name
      if (evaultSelection) {
        this.selectedDocuments = this.removeDuplicates(
          this.selectedDocuments,
          'fileName',
          'uuid',
        );
      } else {
        this.selectedDocuments = this.removeDuplicates(
          this.selectedDocuments,
          'name',
          'uploadDate',
        );
      }
    },
    fileSizeValidation(): void {
      const fileSizeLimit = 5242880;
      this.uploadedDocuments.forEach((file) => {
        this.totalFileSize += file.size;
        if (this.totalFileSize > fileSizeLimit) {
          this.filesWithError.push({
            type: 'size',
            file,
          });
        }
      });

      if (this.filesWithError.length > 0) {
        this.filesWithError.forEach((errorInformation) => {
          const index = this.uploadedDocuments.indexOf(errorInformation.file);
          this.uploadedDocuments.splice(index, 1);
        });
        this.fileTypeError = true;
      }
    },
    fileTypeValidation(): void {
      const allowedTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/bmp',
        'image/tiff',
        'image/tif',
        'image/gif',
        'application/pdf',
      ];

      this.uploadedDocuments.forEach((file) => {
        if (allowedTypes.indexOf(file.type) < 0) {
          this.filesWithError.push({
            type: 'type',
            file,
          });
        }
      });

      if (this.filesWithError.length > 0) {
        this.filesWithError.forEach((errorInformation) => {
          const index = this.uploadedDocuments.indexOf(errorInformation.file);
          this.uploadedDocuments.splice(index, 1);
        });
        this.fileTypeError = true;
      }
    },
    removeDuplicates(arr, key, timestamp): any {
      if (!(arr instanceof Array) || (key && typeof key !== 'string')) {
        return false;
      }
      if (key && typeof key === 'string') {
        return arr.filter((obj, index, items) => {
          return (
            items.map((mapObj) => mapObj[key]).indexOf(obj[key]) === index &&
            items.map((mapObj) => mapObj[timestamp]).indexOf(obj[timestamp]) ===
              index
          );
        });
      } else {
        return arr.filter(function(item, index, items) {
          return items.indexOf(item) === index;
        });
      }
    },
  },
  computed: {
    // Add display selected files, return in alpha order
    displayDocuments(): any {
      const documents = [
        ...this.uploadedDocuments,
        ...this.selectedDocuments,
      ].sort((a, b) => {
        let nameA = '',
          nameB = '';
        if (a.name) {
          nameA = a.name.toUpperCase();
        } else if (a.Name) {
          nameA = a.Name.toUpperCase();
        }
        if (b.name) {
          nameB = b.name.toUpperCase();
        } else if (b.Name) {
          nameB = b.Name.toUpperCase();
        }
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });
      this.$emit('newSelectedFiles', documents);
      return documents;
    },
  },
  components: {
    ChooseFileFromVault,
  },
});
